import { defineComponent as _defineComponent } from 'vue'
import { BaseCell } from '@warrenbrasil/nebraska-web';

interface Props {
  name: string;
  category: string;
  marketType?: string;
  isEnabledSecondaryMarket: boolean;
  isMarketOpen: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductNameCell',
  props: {
    name: null,
    category: null,
    marketType: null,
    isEnabledSecondaryMarket: { type: Boolean },
    isMarketOpen: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,BaseCell }
}

})